import { pascalToCamelCase } from '../stringUtils'

export function getBookingStateText (t, bookingState) {
  return t(pascalToCamelCase(bookingState))
}
